import axios from "./axiosWrapper";

const emailExists = (email='')=>{
    return new Promise((resolve, reject) => {
            axios.head(`/emails/${encodeURIComponent(email)}`).then((response) => {
                resolve(1);
            }).catch((error) => {
                reject(error);
            });
    });
}

export default emailExists;
